export const handleError = (error) => {
  if (error.response) {
    const detail = `detail: ${error.response.data.error}` || '';
    const statusCode = error.response.data.code || error.response.status;
    if (
      parseInt(error.response.status, 10) === 401 ||
      parseInt(error.response.status, 10) === 403
    )
      return console.error(statusCode, 'Need authorization!', detail);

    return console.error(statusCode, detail);
  }
  if (error.request) {
    return console.error('Server no response.');
  }
  return console.error(error.message);
};

// An error carrying `request` but no `response` means the browser sent the
// upload and never heard back. The server may well have stored the files and
// only the reply was lost, so re-uploading is exactly what creates duplicates
// — callers use this to tell the user to refresh and check first.
export const classifyUploadError = (error) => {
  if (error?.response) {
    const status = parseInt(error.response.status, 10);
    if (status === 401 || status === 403) return 'auth';
    if (status === 413) return 'tooLarge';
    return 'server';
  }
  if (error?.request) return 'noResponse';
  return 'unknown';
};
